import { render, staticRenderFns } from "./ResetSubmit.vue?vue&type=template&id=3ad7c861&scoped=true"
import script from "./ResetSubmit.vue?vue&type=script&lang=js"
export * from "./ResetSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7c861",
  null
  
)

export default component.exports